export default "__VITE_PUBLIC_ASSET__f0f54da5__"